import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-date-selection',
  templateUrl: './modal-date-selection.component.html',
  styleUrls: ['./modal-date-selection.component.css']
})
export class ModalDateSelectionComponent implements OnInit {

  // estado pagina
  public viewStatus:number=1;
  public initYear:number=null;
  public initMonth:number=null;
  public selectedDate:string=null;

  public listMonths:CatalogModel[]=[];
  public listMonthsFiltered:CatalogModel[]=[];
  public selectedMonths:any[]=[];


  constructor(
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    this.viewStatus = 1;

    var currentTime = new Date()
    var currentMonth = currentTime.getMonth() + 1
    var currentYear = currentTime.getFullYear();
    var currentDay = currentTime.getDate();

    if(currentMonth === 1){ //Enero
      this.initMonth = 12;
      this.initYear = currentYear - 1;
    }else{
      this.initMonth = currentMonth - 3;
      this.initYear = currentYear;
    }

    let startDate = this.initYear + "-" + (this.initMonth<10 ? "0"+this.initMonth : this.initMonth) + "-01";
    let endDate =  currentYear + "-" + (currentMonth<10 ? "0"+currentMonth : currentMonth) + "-01";

    this.generateMonthsRange(startDate, endDate);
  }

  accept=()=> {
    if(this.selectedDate !== null && this.selectedDate.length > 0){
      console.log(">> this.selectedDate=", this.selectedDate)
      this.modalService.dismissAll(this.selectedDate);
    }else{
      this.toastr.info('Seleccione una Fecha!');
    }
  }
  close=()=> this.modalService.dismissAll(null);

  onMonthChange=(e: any[])=>{
    this.selectedMonths = e;
    if(this.selectedMonths.length > 0){
      let month = this.selectedMonths[0].id;
      this.selectedDate = this.initYear + "-" + (month<10 ? "0"+month : month);
    }
  }

  generateMonthsRange(startDate: string, endDate: string) {
    var start      = startDate.split('-');
    var end        = endDate.split('-');
    var startYear  = parseInt(start[0]);
    var endYear    = parseInt(end[0]);

    for(var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1])-1 : 0;
      for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
        var month = j+1;
        var displayMonth = month < 10 ? '0'+month : month;
        switch (month) {
          case 1:
            displayMonth="ENERO";
            break;
          case 2:
            displayMonth="FEBRERO";
            break;
          case 3:
            displayMonth="MARZO";
            break;
          case 4:
            displayMonth="ABRIL";
            break;
          case 5:
            displayMonth="MAYO";
            break;
          case 6:
            displayMonth="JUNIO";
            break;
          case 7:
            displayMonth="JULIO";
            break;
          case 8:
            displayMonth="AGOSTO";
            break;
          case 9:
            displayMonth="SEPTIEMBRE";
            break;
          case 10:
            displayMonth="OCTUBRE";
            break;
          case 11:
            displayMonth="NOVIEMBRE";
            break;
          case 12:
            displayMonth="DICIEMBRE";
            break;
          default:
              console.log("No such day exists!");
              break;
        }
        let option1 = new CatalogModel();
            option1.id = month;
            option1.description = displayMonth + " " + i;

        this.listMonthsFiltered.push(option1);
      }

    }

  }

}
